// App.js - Main Application Component
import React, { useState } from 'react';
import { getItemJSON } from './utils/storage';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import CandidateRegistration from './pages/CandidateRegistration';
import EmployerRegistration from './pages/EmployerRegistration';
import UnifiedLogin from './pages/UnifiedLogin';
import AdminDashboard from './pages/AdminDashboard';
import CandidateDashboard from './pages/CandidateDashboard';
import EmployerDashboard from './pages/EmployerDashboard';
import ResetPassword from './pages/ResetPassword';
import AllJobs from './pages/AllJobs';
import './App.css';

function App() {
  const [user, setUser] = useState(null);
  
  // Check for existing login sessions on app load
  React.useEffect(() => {
    const candidateSession = getItemJSON('candidateLoggedIn');
    const employerSession = getItemJSON('employerLoggedIn');
    const adminSession = getItemJSON('adminLoggedIn');

    if (candidateSession) {
      setUser(candidateSession);
    } else if (employerSession) {
      setUser(employerSession);
    } else if (adminSession) {
      setUser(adminSession);
    }
  }, []);
  
  return (
    <Router>
      <div className="App">
        <Header user={user} setUser={setUser} />
        <div className="App-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/candidate-registration" element={<CandidateRegistration />} />
            <Route path="/employer-registration" element={<EmployerRegistration />} />
            <Route path="/login" element={<UnifiedLogin setUser={setUser} />} />
            <Route path="/candidate-dashboard" element={<CandidateDashboard setUser={setUser} />} />
            <Route path="/employer-dashboard" element={<EmployerDashboard user={user} setUser={setUser} />} />
            <Route path="/admin-dashboard" element={<AdminDashboard setUser={setUser} />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/all-jobs" element={<AllJobs />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;